import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '../../Themes'

const sizes = {
  big: 28,
  medium: 20,
  small: 14
}

const StyledIcon = styled(({ type, size, ...rest }) => <FontAwesomeIcon {...rest} />)`
  margin-right: ${props => props.gap || 16}px;
  font-size: ${props => sizes[props.type] || sizes.small}px;
  color: ${props => props.color || Colors.greyishBrown};
`
export default StyledIcon
